var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-2",
    class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
    staticStyle: { margin: "20px" },
    attrs: {
      headers: _vm.headers,
      items: _vm.filterActivities,
      page: _vm.pagination.page,
      "items-per-page": _vm.paginationActivitiesTable.rowsPerPage,
      loading: _vm.loading,
      "loading-text": "",
      "items-per-page-text": _vm.rowsPerPageText,
      "items-per-page-items": _vm.rowsPerPageItems,
      "header-props": { sortIcon: _vm.sortIcon },
      "footer-props": {
        prevIcon: _vm.prevIcon,
        nextIcon: _vm.nextIcon,
        "items-per-page-options": _vm.rowsPerPageItems
      }
    },
    on: {
      "update:page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationActivitiesTable, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationActivitiesTable, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableActivitiesId,
          _vm.paginationActivitiesTable.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "headers",
        fn: function() {
          return [
            _c(
              "tr",
              [
                _c(
                  "activity-table-header-cell",
                  {
                    attrs: {
                      header: _vm.headers[0],
                      pagination: _vm.pagination,
                      filterActive: _vm.filters.state ? true : false
                    },
                    on: { sort: _vm.changeSort }
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: _vm.$t("State"),
                        items: _vm.stateOptions,
                        pagination: _vm.pagination,
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.state,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "state", $$v)
                        },
                        expression: "filters.state"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("activity-table-header-cell", {
                  attrs: { header: _vm.headers[1], pagination: _vm.pagination },
                  on: { sort: _vm.changeSort }
                }),
                _vm._v(" "),
                _c(
                  "activity-table-header-cell",
                  {
                    attrs: {
                      header: _vm.headers[2],
                      pagination: _vm.pagination,
                      filterActive: _vm.filters.activity ? true : false
                    },
                    on: { sort: _vm.changeSort }
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: _vm.$tc("Activity", 1),
                        items: _vm.activities,
                        "item-text": "title",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.activity,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "activity", $$v)
                        },
                        expression: "filters.activity"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "activity-table-header-cell",
                  {
                    attrs: {
                      header: _vm.headers[3],
                      pagination: _vm.pagination,
                      filterActive: _vm.filters.layer ? true : false
                    },
                    on: { sort: _vm.changeSort }
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: _vm.$tc("Layer", 1),
                        items: _vm.objectTypeOptions,
                        "item-value": "layer",
                        "item-text": "type_name",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.layer,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "layer", $$v)
                        },
                        expression: "filters.layer"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "activity-table-header-cell",
                  {
                    attrs: {
                      header: _vm.headers[4],
                      pagination: _vm.pagination,
                      filterActive: _vm.filters.labelObject ? true : false
                    },
                    on: { sort: _vm.changeSort }
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: _vm.$tc("Object", 1),
                        items: _vm.activities,
                        "item-text": function(item) {
                          return item.labelObject
                            ? item.labelObject
                            : "No Objects"
                        },
                        "item-value": function(item) {
                          return item.labelObject
                            ? item.labelObject
                            : "No Objects"
                        },
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.labelObject,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "labelObject", $$v)
                        },
                        expression: "filters.labelObject"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "activity-table-header-cell",
                  {
                    attrs: {
                      header: _vm.headers[5],
                      pagination: _vm.pagination,
                      filterActive: _vm.filters.creator ? true : false
                    },
                    on: { sort: _vm.changeSort }
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: _vm.$t("Creator"),
                        items: _vm.allUsers,
                        "item-text": function(item) {
                          return _vm.getUserName(item.id)
                        },
                        "item-value": function(item) {
                          return item.id
                        },
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.creator,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "creator", $$v)
                        },
                        expression: "filters.creator"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "activity-table-header-cell",
                  {
                    attrs: {
                      header: _vm.headers[6],
                      pagination: _vm.pagination,
                      filterActive: _vm.filters.startDate ? true : false
                    },
                    on: { sort: _vm.changeSort }
                  },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 40,
                          lazy: "",
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "min-width": "290px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t("From"),
                                        "append-icon": "event",
                                        readonly: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.filters.startDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "startDate",
                                            $$v
                                          )
                                        },
                                        expression: "filters.startDate"
                                      }
                                    },
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.startDateMenu,
                          callback: function($$v) {
                            _vm.startDateMenu = $$v
                          },
                          expression: "startDateMenu"
                        }
                      },
                      [
                        _vm._v(" "),
                        _c("v-date-picker", {
                          attrs: { color: "accent", "no-title": "" },
                          on: {
                            input: function($event) {
                              _vm.startDateMenu = false
                            }
                          },
                          model: {
                            value: _vm.filters.startDate,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "startDate", $$v)
                            },
                            expression: "filters.startDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 40,
                          lazy: "",
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "min-width": "290px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t("To"),
                                        "append-icon": "event",
                                        readonly: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.filters.endDate,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filters, "endDate", $$v)
                                        },
                                        expression: "filters.endDate"
                                      }
                                    },
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.endDateMenu,
                          callback: function($$v) {
                            _vm.endDateMenu = $$v
                          },
                          expression: "endDateMenu"
                        }
                      },
                      [
                        _vm._v(" "),
                        _c("v-date-picker", {
                          attrs: { color: "accent", "no-title": "" },
                          on: {
                            input: function($event) {
                              _vm.endDateMenu = false
                            }
                          },
                          model: {
                            value: _vm.filters.endDate,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "endDate", $$v)
                            },
                            expression: "filters.endDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("activity-table-header-cell", {
                  attrs: { header: _vm.headers[7], pagination: _vm.pagination },
                  on: { sort: _vm.changeSort }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "item",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                class: { "cursor-pointer": _vm.userHasPermissionTo("show") },
                on: {
                  click: function($event) {
                    return _vm.$emit("openActivity", props.item.uuid)
                  }
                }
              },
              [
                _c(
                  "td",
                  [
                    _c("activity-task-status-icon", {
                      attrs: {
                        status: props.item.state,
                        delayed: _vm.isDelayed(props.item)
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v("\n        -\n      ")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n        " + _vm._s(props.item.title) + "\n      ")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getObjectTypeLabel(props.item.object_type)) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        props.item.labelObject ? props.item.labelObject : "-"
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", "align-center": "" } },
                      [
                        _vm.getCreatorType(props.item.user_creator_id) !== "-"
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { small: "", color: "accent" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getCreatorType(
                                        props.item.user_creator_id
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getUserName(props.item.user_creator_id))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFormattedDate(props.item.due_date)) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", text: "", color: "accent" },
                        on: {
                          click: function($event) {
                            return _vm.viewInMap(props.item.geoJson)
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("gps_fixed")])],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]
        }
      },
      {
        key: "pageText",
        fn: function(props) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(props.pageStart) +
                " - " +
                _vm._s(props.pageStop) +
                " " +
                _vm._s(_vm.$t("tables.Of")) +
                "\n    " +
                _vm._s(props.itemsLength) +
                "\n  "
            )
          ]
        }
      },
      {
        key: "no-data",
        fn: function() {
          return [_vm.loading ? _c("div") : _vm._e()]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3afc9b1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afc9b1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Activities/ActivitiesTable.vue
// module id = null
// module chunks = 